const {
  REACT_APP_LOGIN_SECRET,
} = process.env;


const constants = {
  LOGIN_SECRET: REACT_APP_LOGIN_SECRET,
};


export default constants;



// WEBPACK FOOTER //
// ./src/config/constants.js